import React from 'react';
import { motion } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
import { Store, ArrowRight } from 'lucide-react';
const sellables = ['DIY Products', 'Plans', 'Blueprints', 'Templates', 'Digital Downloads', 'AI Prompts', 'Workshops', 'Courses'];
export function MarketplaceTeaser() {
  return <section className="py-32 relative overflow-hidden bg-navy-900 dark:bg-navy-950" data-id="element-209">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-210">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-forest-500/10 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/3" data-id="element-211" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-orange-500/10 rounded-full blur-[100px] translate-y-1/3 -translate-x-1/4" data-id="element-212" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-213">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-214">
          <div data-id="element-215">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-216">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 bg-white/5 backdrop-blur-md text-white text-sm font-semibold mb-8" data-id="element-217">
                <Store size={16} className="text-orange-400" data-id="element-218" /> Coming Soon
              </div>
              <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-219">
                The Future <br data-id="element-220" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-forest-400 to-green-300" data-id="element-221">
                  Maker Marketplace.
                </span>
              </h2>
              <p className="text-xl text-gray-300 mb-10 max-w-lg font-light leading-relaxed" data-id="element-222">
                Turn your passion into a business. Sell your designs, teach your
                skills, and monetize your maker knowledge.
              </p>

              <div className="flex flex-wrap gap-3 mb-12" data-id="element-223">
                {sellables.map((item, index) => <motion.span key={item} initial={{
                opacity: 0,
                scale: 0.9
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.05
              }} className="px-4 py-2 rounded-full bg-white/10 border border-white/10 text-white text-sm font-medium" data-id="element-224">
                    {item}
                  </motion.span>)}
              </div>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-card rounded-3xl p-8 md:p-10 border border-white/20 bg-white/10 backdrop-blur-xl relative overflow-hidden" data-id="element-225">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-orange-400 to-orange-600" data-id="element-226" />

            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-227">
              Join the Waitlist
            </h3>
            <p className="text-gray-300 mb-8" data-id="element-228">
              Be the first to know when we launch the marketplace and get early
              access to seller tools.
            </p>

            <form className="space-y-4" onSubmit={e => {
            e.preventDefault();
            window.location.href = AGREEXA_APP_URL;
          }} data-id="element-229">
              <div data-id="element-230">
                <label htmlFor="email" className="sr-only" data-id="element-231">
                  Email address
                </label>
                <input type="email" id="email" placeholder="Enter your email address" className="w-full bg-navy-900/50 border border-white/20 rounded-xl px-5 py-4 text-white placeholder-gray-400 focus:outline-none focus:border-orange-500 transition-colors" data-id="element-232" />
              </div>
              <button type="submit" className="w-full py-4 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg transition-all flex items-center justify-center gap-2 shadow-lg shadow-orange-500/25" data-id="element-233">
                Get Early Access <ArrowRight size={20} data-id="element-234" />
              </button>
            </form>

            <p className="text-xs text-gray-400 text-center mt-6" data-id="element-235">
              No spam. Unsubscribe at any time.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}